<template>
  <div
    class="l-page"
    :class="'l-page--' + $route.name"
    :style="{ 'padding-top': notificationsHeight + 'px' }"
  >
    <Loading
      v-if="isLoading || isLoadingMain"
      :variant="isLoadingMain ? 'main' : 'page'"
    />
    <Notifications />
    <Side v-if="hasSide" :project="project" />
    <SideInfo v-if="hasSideInfo" />
    <div class="l-content">
      <Header
        v-if="hasHeader"
        :project="project"
        :requiresAuth="requiresAuth"
        :hasSide="hasSide || hasSideInfo"
      />
      <router-view v-if="!isLoadingMain" :project="project" />
      <Footer v-if="hasFooter" />
    </div>
    <transition name="v-fade-in">
      <StickyFormAddTask v-if="hasTask" :project="project" />
    </transition>
    <portal-target class="c-tooltip-portal" name="portal-tooltip" />
  </div>
</template>

<script>
import Footer from '@/components/layouts/Footer';
import Header from '@/components/layouts/Header';
import Loading from '@/components/Loading';
import Notifications from '@/components/notifications/Notifications';
import Side from '@/components/layouts/Side';
import SideInfo from '@/components/layouts/SideInfo';
import StickyFormAddTask from '@/components/taskList/StickyFormAddTask';

export default {
  components: {
    Footer,
    Header,
    Loading,
    Notifications,
    Side,
    SideInfo,
    StickyFormAddTask
  },

  computed: {
    hasFooter() {
      return this.$route.matched.some(record => record.meta.hasFooter);
    },
    hasHeader() {
      return this.$route.matched.some(record => record.meta.hasHeader);
    },
    hasSide() {
      return this.$route.matched.some(record => record.meta.hasSide);
    },
    hasSideInfo() {
      return this.$route.matched.some(record => record.meta.hasSideInfo);
    },
    hasTask() {
      return this.$route.matched.some(record => record.meta.hasTask);
    },
    notificationsHeight() {
      return this.$store.state.view.size.notificationsHeight;
    },
    project() {
      return this.$store.getters['view/project'];
    },
    projectId() {
      return this.$route.params.projectId;
    },
    requiresAuth() {
      return this.$route.matched.some(record => record.meta.requiresAuth);
    },
    isLoading() {
      return this.$store.state.view.isLoading;
    },
    isLoadingMain() {
      return this.$store.state.view.isLoadingMain;
    }
  }
};
</script>

<style lang="scss"></style>
